module.exports = __webpack_public_path__ + "img/1.41d95516.png";